import { LIKES } from './Base';

//
// All like states are handled in the company reducer src/reducers/company.js as it holds the state for the company feed
//

export const onCreateLikeRequest = (payload = {}, cb) => ({ payload, cb, type: LIKES.CREATE_REQUEST });
export const onCreateLikeFailure = (payload = {}) => ({ payload, type: LIKES.CREATE_FAILURE });
export const onCreateLikeSuccess = (payload = {}) => ({ payload, type: LIKES.CREATE_SUCCESS });

export const onDeleteLikeRequest = (payload = {}, cb) => ({ payload, cb, type: LIKES.DELETE_REQUEST });
// export const onDeleteLikeFailure = (payload = {}) => ({ payload, type: LIKES.DELETE_FAILURE }); NOT FIXED - ADD TO COMPANY REDUCER
export const onDeleteLikeSuccess = (payload = {}) => ({ payload, type: LIKES.DELETE_SUCCESS });

export const onGetLikesRequest = (payload = {}, cb) => ({ payload, cb, type: LIKES.GET_REQUEST });
// export const onGetLikesFailure = (payload = {}) => ({ payload, type: LIKES.GET_FAILURE }); NOT FIXED - ADD TO COMPANY REDUCER
export const onGetLikesSuccess = (payload = {}) => ({ payload, type: LIKES.GET_SUCCESS });
